import gql from 'graphql-tag';

export const ELEMENTS_USPS_QUERY = gql`
  query {
    elements {
      uniqueSellingPropositions {
        id
        text
        position
      }
    }
  }
`;
